<template>
  <view>
    <view class="personalCenter">
      <view class="head" />
      <view class="main">
        <image
          v-show="!show"
          mode="aspectFill"
          :src="noImg"
          class="head-img"
        />
        <view class="top">
          <view>
            <p class="font-16">
              仓仔
            </p>
            <p class="tel color-666 font-13">
              18305451251
            </p>
          </view>
          <view @click="show=!show">
            <p class="color-999 font-13">
              修改/完善信息
            </p>
          </view>
        </view>
        <ul>
          <li
            v-for="(item,index) in menuList"
            :key="index"
            @click="$jumpUrl(item.url)"
          >
            <view class="left">
              <image
                mode="aspectFill"
                :src="noImg"
                class="icon"
              />
              <span>{{ item.title }}</span>
            </view>
            <b
              v-show="item.title=='我的积分'"
              class="font-16"
            >
              688<span class="font-15">分</span>
            </b>
          </li>
        </ul>
      </view>
      <view :class="!show?'label hide':'label show'">
        <p
          class="title color-999"
          @click="show=false"
        >
          跳过
        </p>
        <ul>
          <li
            v-for="(item,index) in label"
            :key="index"
            :class="labelCheck.indexOf(item)>-1?'s color-999':'color-999'"
            @click="labelClick(item)"
          >
            {{ item }}
          </li>
        </ul>
        <p class="notes">
          最多可选择五个标签
        </p>
        <button class="button">
          提交
        </button>
      </view>
    </view>
  </view>
</template>

<script>
export default {
	data(){
		return{
			noImg:require('static/logo.png'),
			menuList:[
				{
					icon:'',
					title:'活动预约',
					url:'/pages/personalCenter/activity/list'
				},
				{
					icon:'',
					title:'我的积分',
					url:'/pages/personalCenter/myIntegral'
				},
				{
					icon:'',
					title:'消息通知',
					url:'/pages/personalCenter/notify'
				}
			],
			show:false,
			label:['80后','90后','70后','资深滑雪爱好者','徒步爱好者','爱美食'],
			labelCheck:[]
		};
	},
	methods:{
		labelClick(item){			
			let index=this.labelCheck.indexOf(item);
			if(index<0&&this.labelCheck.length>4){
				uni.showToast({
					title:'最多可选择五个标签',
					icon:'none'
				});
				return;
			}
			if(index>-1){
				this.labelCheck.splice(index,1);
			}else{
				this.labelCheck.push(item);
			}
		}
	}
};
</script>

<style lang="less" scoped>
.personalCenter{
	height:100vh;
	position: relative;
	overflow: hidden;
}
.head{
	width:750upx;
	height:434upx;
	position: relative;
	margin-bottom: -50upx;
	background:red;
}
.label{
	width:100%;
	height:1000upx;
	border-radius:40upx 40upx 0px 0px;
	background: #FFF;
	padding:50upx;
	box-sizing: border-box;
	position: absolute;
	left:0;
	bottom:0;
	z-index: 99;
	transition: all .5s ease;
	&.hide{		
		transform: translateY(100%);
	}
	&.show{
		transform: translateY(0);
	}
	ul{
		overflow: hidden;
		li{
			background:#f3f3f3;
			border-radius: 4upx;
			padding:14upx 34upx;
			margin:30upx 30upx 0 0;
			float: left;
		}
		.s{
			background:#E3B979;
			color:#FFF;
		}
	}
	.title{
		text-align: right;
	}
	.notes{
		color:#C3986D;
		margin-top:80upx;
		text-align: center;
	}
	.button{
		width:500upx;
		height:90upx;
		background:#E3B979;
		border-radius: 4upx;
		color:#FFF;
		text-align: center;
		line-height: 90upx;
		position: absolute;
		bottom:60upx;
		left:120upx;
		&:after{			
			border:none;
		}
	}
}
.main{
	width:100%;
	border-radius:40upx 40upx 0px 0px;
	position: relative;
	background: #FFF;
	padding-top:30upx;
	.head-img{
		width:160upx;
		height:160upx;
		position: absolute;
		left:30upx;
		top:-70upx;
		border-radius: 160upx;
	}
	.top{
		display: flex;
		justify-content: space-between;
		margin:0 28upx 0 220upx;
		.tel{
			margin-top:16upx;
		}
	}
	ul{
		margin:70upx 30upx;
		overflow: hidden;
		li{
			border-bottom:1upx #D8D8D8 solid;
			font-weight: 500;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding:30upx 14upx 30upx 0;
			&:last-child{
				border-bottom: none;
			}
		}
		.left{
			display: flex;
			align-items: center;
		}
		.icon{
			width:40upx;
			height:40upx;
			margin-right:24upx;
		}
	}
}
</style>
